import type { User } from '@datadog/browser-core';
export const deferredDatadog = {
    addAction: async <TContext extends object | undefined>(action: string, context?: TContext) => {
        const { datadog } = await import(
            /* webpackChunkName: "datadog" */
            'src/services/datadog'
        );
        datadog.addAction(action, context);
    },
    setUser: async (user: User) => {
        const { datadog } = await import(
            /* webpackChunkName: "datadog" */
            'src/services/datadog'
        );
        datadog.setUser(user);
    },
    addFeatureFlagEvaluation: async <TExperimentName extends string, TValue>(
        experimentName: TExperimentName,
        experimentValue: TValue
    ) => {
        const { datadog } = await import(
            /* webpackChunkName: "datadog" */
            'src/services/datadog'
        );
        datadog.addFeatureFlagEvaluation(experimentName, experimentValue);
    },
    addError: async <TError, TContext extends object | undefined>(error: TError, context?: TContext) => {
        const { datadog } = await import(
            /* webpackChunkName: "datadog" */
            'src/services/datadog'
        );
        datadog.addError(error, context);
    },
};
